import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    priceList: [],
    filter: [],
    zoomLvl: 1,
    mobile: (window.innerWidth <= 700),
    BasketLines: [],
    pointshop: false,
    pointBalance: 0,
    priceListFilterPills: [],
    searchResult: {
      show: false,
      result: [{globalProducts: []}],
    }
  },
  mutations: {
    loadingHandler(state, value) {
      state.loading = value;
    },
    applyPriceList(state, value) {
      state.priceList = value;
    },
    setFilter(state, value) {
      state.filter = value;
      if (typeof window.ajaxBasket != 'undefined') {
        window.ajaxBasket.refresh()
      }
    },
    forceLoadButtons(state) {
      window.ajaxBasket.refresh()
    },
    applyPoints(state, value) {
      state.pointBalance = value;
    },
    setMobile(state, value) {
      state.mobile = value;
      state.zoomLvl = window.devicePixelRatio
    },
    applyQuantityFromBasket(state, value) {
      state.BasketLines = [];
      value.forEach(element => {
        state.BasketLines.push({ id: element.productID, quantity: element.quantity, isSubscription: element.isSubscription })
      });
    },
    updateSingleProduct(state, val) {
      if (state.BasketLines.length > 0) {
        state.BasketLines.forEach(product => {
          if (product.id == val.productID) {
            product.quantity = val.currentQty;
          } else {
            state.BasketLines.push({ id: val.productID, quantity: val.currentQty, isSubscription: val.isSubscription })
          }
        })
      } else {
        state.BasketLines.push({ id: val.productID, quantity: val.quantity, isSubscription: val.isSubscription })
      }
    },
    applySearchResult(state, value) {
  
      state.searchResult.result = [{globalProducts: []}];
      state.filter = [];
      state.priceListFilterPills = [];
      state.searchResult.result = typeof value != 'undefined' && value.length > 0 ? value : state.searchResult.result;
      state.searchResult.show = true;
      state.loading = false;
      window.ajaxBasket.refresh()
    }
  },
  actions: {
    async collectItemsFromSearchQuery(context, query) {
      context.state.loading = true;
      //await axios.get(window.basedir + "/ajaxRequestServlet?mode=FreeSearch&M_AttributeSet_ID=1000018&isPointShop=" + context.state.pointshop + "&isProductOverview=true", {params: {"searchString": query}}, {
     await axios.get(window.basedir + "/ajaxRequestServlet?mode=FreeSearch&isPointShop=" + context.state.pointshop + "&isProductOverview=true", {params: {"searchString": query}}, {
     
     
     
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        if(statisticsAccepted()) {

      
        gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href.includes('?') ? window.location.href+'&q='+query : window.location.href+'?q='+query,
          page_path: window.location.pathname
        })
        gtag('event', 'Shop search', {
          event_category: 'engagement',
          event_label: query,
        })
        if(window.hasFbq) {
          fbq('track', 'Search', {
            search_string: query
        });
        }
      }
        context.commit('applySearchResult', response.data.productsByAttribute)
      })
    },
    screenSize(context, val) {
      context.commit('setMobile', val)
    },
    updateFilter(context, val) {
      var tempArray = []
      val.forEach(el => {
        tempArray.push(el.attributeValueIds)
      })
      context.dispatch('setFilter', tempArray)
    },
    loadButtons(context) {
      context.commit("forceLoadButtons");
    },
    addOrRemoveQuant(context, val) {
      axios.get(window.basedir + "/ajaxRequestServlet?mode=UpdateQuantity&payload={products:[{productID:" + val.id + ",quantity:" + (val.type == "plus" ? parseInt(val.currentQuant) + 1 : parseInt(val.currentQuant) - 1) + "}], isPointShop: " + (context.state.pointshop ? 'Y' : false) + "}", {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then((response) => {
        if (response.data.errorMessage == "") {
          window.ajaxBasket.refresh()
        } else {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + response.data.errorMessage);
        }

      }).catch(error => {
        alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + error.data.errorMessage);
      });
    },
    async refreshBasket(context, val) {
      if (typeof val != 'undefined') {
        context.commit("applyQuantityFromBasket", val)
      }
    },
    async updatePointShopWidget(context, val) {
      axios.get(basedir + '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"GetPoints","isPointShop":"Y"}', {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        context.commit("applyPoints", response.data.points);
      })

    },
    async getPriceList(context, [showCatAttr, hideCatAttr]) { //uses ES6 argument destructuring to assign the Incoming arrays as variables
    //async getPriceList(context, val) {
      context.commit("loadingHandler", true);
     // await axios.post(basedir + '/ajaxRequestServlet?mode=Search', { isPointShop: context.state.pointshop, target: { products: { noOfResults: 99999, isProductOverview: true } }, attributeValueIds: val, blacklistedAttributeValueIds: valBlack}, {
      await axios.post(basedir + '/ajaxRequestServlet?mode=Search', { isPointShop: context.state.pointshop, target: { products: { noOfResults: 99999, isProductOverview: true } }, attributeValueIds: showCatAttr, blacklistedAttributeValueIds: hideCatAttr}, { //7507084
       
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        context.commit("applyPriceList", response.data.productsByAttribute)
        
        context.commit("setFilter", showCatAttr)
        context.commit("loadingHandler", false);
      })
    },
  },
  getters: {
    priceList: state => {
      return state.priceList;
    },
  }
})
